import {connect} from "react-redux"
import CostComponent from "../../components/CostComponent";
import swal from 'sweetalert2';
import i18n from "i18next";

import { 
  deleteCost,
  deleteCostPhoto,
  sendCostApproval,
  fetchCostList,
  costFormValidation,
  pdfDownload,
  
 } from "../actions/cost";

const mapStateToProps = (state,ownProps) => {
  return {
    costTypeList: state.login.employeeInfo.costType,
    kdvOraniList: state.login.employeeInfo.kdvOrani,
    kdvOraniAktif: state.login.employeeInfo.kdvOraniAktif,
    accessToken: state.login.employeeInfo.accessToken,
    costGroupList: state.cost.costs,
    employeeName:state.login.employeeInfo.employeeName,
    maxCostTime:state.login.employeeInfo.maxCostTime,
    filter:state.cost.filter,
    employeeInfo: state.login.employeeInfo
  }
};
const mapDispatchToProps = (dispatch,state) => {
  return {
    costUpdateFormValidation: (costData,token,cb,employeeInfo) => {
      dispatch(costFormValidation({
        costFormData: costData,
        token: token,
        status: true,
        sendToConfirmation: 0,
        cb: cb,
        employeeInformation: employeeInfo
      }));
    },
    costDeleteButtonAction: (costId,accessToken,cb) => {
      swal({
        title: i18n.t("areYouSure"),
        text: i18n.t("costFormWillCancelled"),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t("yes"),
        cancelButtonText: i18n.t("cancelButton")
      }).then(function () {
        dispatch(deleteCost({'costId': costId, 'accessToken': accessToken,'cb':cb()}));
      }).catch((e) => {
        console.log(e)
      });
    },
    costPhotoDeleteButton:(costPhotoId,accessToken) => {
      dispatch(deleteCostPhoto({costPhotoId,accessToken}));
    },
    costSendToApprovalAction:(costId,accessToken,costGroup) => {
      dispatch(sendCostApproval({costId,accessToken,costGroup}));
    },
      fetchCostList:(month,year,status,token) => {
      dispatch(fetchCostList({'month': month,'year':year,'status': status,'token':token}));
    },
    pdfDownload:(employeeName, costIds, accessToken, language)=> {
      dispatch(pdfDownload({employeeName, costIds, accessToken, language}));
    }
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(CostComponent);
